import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AgreementUsagePortalView } from '@catalyst-psa/shared';

import { publicApi } from '../project-portal/publicApi.js';

/** Fetches the public managed-services usage view for an agreement token. */
export function useAgreementUsagePortal(
  token: string,
): UseQueryResult<AgreementUsagePortalView> {
  return useQuery({
    queryKey: ['public', 'agreement-usage', token],
    enabled: Boolean(token),
    retry: false,
    queryFn: () => publicApi.get<AgreementUsagePortalView>(`/public/agreements/${token}`),
  });
}
